export const Badge = ( { count }) => {
    if (!count) { return }
    const countString = count > 99 ? '99+' : count;
    return (
        <span className="inline-flex items-center justify-center h-4 w-content p-1.5 bg-red-600 text-white font-medium text-xs rounded-full">{ countString }</span>
    )
}